import { generateTypes } from '../utils/HttpReducerHelper';

const inviteRequest = generateTypes('INVITE', 'REQUEST');
const inviteSignUp = generateTypes('INVITE', 'SIGNUP');
const inviteHashSignUp = generateTypes('INVITE', 'SIGNUP_HASH');
const rejectInvite = generateTypes('INVITE', 'REJECT');

export { inviteRequest, inviteSignUp, rejectInvite, inviteHashSignUp };
